<div class="header">
    <h2>People</h2>

    <div class="buttons"
         *ngIf="uniqueInactiveConnections.size > 0">
        <button class="btn btn-pill btn-toolbar"
                [ngClass]="showInactiveConnections ? 'active' : ''"
                [adaptButtonIcon]="showInactiveConnections ? 'fal fa-eye-slash' : 'fal fa-eye'"
                (click)="showInactiveConnections = !showInactiveConnections">
            {{showInactiveConnections ? 'Hide' : 'Show'}} previous people</button>
    </div>
</div>

<div class="role-people-panel">
    <p *ngIf="uniqueActiveConnections.size === 0 && !showInactiveConnections">
        No people are currently allocated to this role.
    </p>
    <div class="role-people">
        @for (connection of uniqueActiveConnections; track connection.connectionId) {
            <div class="d-flex flex-row gap-2 align-items-center">
                <adapt-link-person [person]="connection.person"
                                   [showImage]="true"
                                   class="role-people-position"></adapt-link-person>
                <adapt-display-role-connection-handover-status *ngIf="activeRoleConnectionForConnection.get(connection) as roleConnection"
                                                               [roleConnection]="roleConnection">
                </adapt-display-role-connection-handover-status>
            </div>
        }
    </div>

    <h3 class="mt-3"
        *ngIf="showInactiveConnections">Previous People</h3>
    <div class="role-people"
         *ngIf="showInactiveConnections">
        @for (connection of uniqueInactiveConnections; track connection.connectionId) {
            <adapt-link-person [person]="connection.person"
                               [showImage]="true"
                               class="role-people-position"></adapt-link-person>
        }
    </div>
</div>
